import React, { SVGProps } from 'react';

/**
 * Resync icon for the Zoho integration.
 *
 * Mirrors the design-system Resync*SmIcon contract (16x16 viewBox, the brand
 * mark centred on (8,8), currentColor fill/stroke) so it behaves
 * identically to its siblings returned by getResyncIconForIntegrationType.
 */
const ResyncZohoIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      className={['size-6', className].filter(Boolean).join(' ')}
      {...props}
    >
      {/*
        Zoho mark: the four tiles of the logo, without the wordmark, scaled to
        an 8 wide footprint and centred on (8,8).
      */}
      <g transform="translate(3.513 3.862) scale(0.1612)">
        <path
          fill="currentColor"
          d="M25.2261 34.3255C24.8482 34.3255 24.4654 34.247 24.0973 34.085L16.2445 30.5856C14.8408 29.9623 14.2077 28.3083 14.831 26.9046L18.3304 19.0519C18.9537 17.6482 20.6077 17.015 22.0114 17.6384L29.8642 21.1378C31.2679 21.7611 31.901 23.4151 31.2777 24.8188L27.7783 32.6715C27.312 33.712 26.2912 34.3255 25.2261 34.3255ZM24.75 32.6126C25.3439 32.8777 26.0408 32.6077 26.3059 32.0188L29.8053 24.166C30.0703 23.5721 29.8004 22.8752 29.2114 22.6102L21.3537 19.1108C20.7598 18.8457 20.0629 19.1157 19.7979 19.7046L16.2985 27.5574C16.0334 28.1513 16.3034 28.8482 16.8923 29.1132L24.75 32.6126Z"
        />
        <path
          fill="currentColor"
          d="M49.8587 34.3286H41.2599C39.7237 34.3286 38.4722 33.077 38.4722 31.5408V22.942C38.4722 21.4058 39.7237 20.1543 41.2599 20.1543H49.8587C51.3949 20.1543 52.6465 21.4058 52.6465 22.942V31.5408C52.6465 33.077 51.3949 34.3286 49.8587 34.3286ZM41.2599 21.7641C40.6121 21.7641 40.082 22.2942 40.082 22.942V31.5408C40.082 32.1887 40.6121 32.7188 41.2599 32.7188H49.8587C50.5066 32.7188 51.0366 32.1887 51.0366 31.5408V22.942C51.0366 22.2942 50.5066 21.7641 49.8587 21.7641H41.2599Z"
        />
        <path
          fill="currentColor"
          d="M17.6583 24.5188L16.5 27.1102C16.4852 27.1396 16.4705 27.1642 16.4558 27.1887L16.9073 29.9765C17.0104 30.6194 16.5736 31.2231 15.9356 31.3262L7.44473 32.7004C7.13552 32.7495 6.82141 32.6759 6.5662 32.4943C6.31098 32.3127 6.14411 32.0378 6.09503 31.7286L4.72079 23.2378C4.67171 22.9286 4.74533 22.6145 4.92693 22.3593C5.10852 22.104 5.38337 21.9372 5.69257 21.8881L14.1834 20.5139C14.2472 20.504 14.311 20.4991 14.3699 20.4991C14.9343 20.4991 15.4398 20.9114 15.5331 21.4905L15.9895 24.2979L17.1871 21.6132L17.1233 21.2353C16.8779 19.7188 15.4448 18.6832 13.9282 18.9286L5.43736 20.3028C4.70607 20.4157 4.05821 20.8132 3.62631 21.4169C3.1895 22.0206 3.01772 22.7568 3.13551 23.493L4.50975 31.9838C4.62754 32.72 5.02509 33.363 5.62877 33.7998C6.10485 34.1483 6.66927 34.3249 7.25332 34.3249C7.40056 34.3249 7.5527 34.3151 7.70485 34.2906L16.1957 32.9164C17.7122 32.671 18.7478 31.2378 18.5024 29.7212L17.6583 24.5188Z"
        />
        <path
          fill="currentColor"
          d="M27.8405 28.5727L29.0871 25.78L28.7337 23.1837C28.6896 22.8745 28.773 22.5653 28.9644 22.315C29.1558 22.0647 29.4307 21.9027 29.7448 21.8635L38.2651 20.7052C38.3191 20.7003 38.373 20.6954 38.427 20.6954C38.6822 20.6954 38.9276 20.7788 39.1387 20.9359C39.178 20.9653 39.2123 20.9997 39.2467 21.0291C39.6246 20.6316 40.1203 20.3469 40.6749 20.2242C40.5178 20.0082 40.3313 19.8168 40.1105 19.65C39.5166 19.1984 38.7853 19.007 38.0491 19.1052L29.519 20.2635C28.7828 20.3616 28.1252 20.7444 27.6785 21.3383C27.227 21.9322 27.0356 22.6635 27.1337 23.3997L27.8405 28.5727Z"
        />
        <path
          fill="currentColor"
          d="M42.3391 30.0111L41.2201 21.7656C40.5918 21.7853 40.0863 22.3055 40.0863 22.9386V25.3583L40.7489 30.227C40.7931 30.5362 40.7096 30.8454 40.5182 31.0957C40.3268 31.346 40.052 31.508 39.7378 31.5473L31.2176 32.7055C30.9084 32.7497 30.5992 32.6663 30.3489 32.4749C30.0986 32.2835 29.9366 32.0086 29.8973 31.6945L29.5047 28.8037L28.2581 31.5963L28.3022 31.9104C28.4004 32.6466 28.7832 33.3043 29.3771 33.7509C29.8679 34.1239 30.4519 34.3203 31.0605 34.3203C31.1881 34.3203 31.3157 34.3105 31.4433 34.2957L39.9538 33.1473C40.69 33.0491 41.3477 32.6663 41.7943 32.0724C42.2458 31.4785 42.4372 30.7473 42.3391 30.0111Z"
        />
      </g>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.999992}
        d="M0.666748 7.47858L1.71436 6.43097L2.76197 7.47858"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.999992}
        d="M15.3335 8.52338L14.2859 9.57099L13.2383 8.52338"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.999992}
        d="M2.88599 4.36105C4.61492 1.90839 7.83822 1.02283 10.5776 2.24788C13.3169 3.47293 14.8058 6.46578 14.1303 9.38958"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.999992}
        d="M13.1112 11.6378C11.3822 14.0905 8.15893 14.9761 5.41958 13.751C2.68024 12.526 1.19139 9.53311 1.86683 6.60931"
      />
    </svg>
  );
};

export default ResyncZohoIcon;
